import type { MouseEventHandler, ReactNode, RefObject } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import { Box } from '@mui/material';

import Typography from '@/components/Typography';

const Header = ({
  icon,
  title,
  subtitle,
  headerAction,
  historyButtonRef,
  onClose,
  onHistoryClick,
  isHistoryActive
}: {
  onClose: MouseEventHandler;
  title: string;
  subtitle?: ReactNode;
  icon: ReactNode;
  historyButtonRef?: RefObject<HTMLElement | null>;
  headerAction?: ReactNode;
  onHistoryClick?: () => void;
  isHistoryActive?: boolean;
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid var(--GX-Text-Disabled, #6C737A)',
        background: 'var(--GX-Main-Background, #070818)'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pl: '24px',
          pr: '32px',
          width: '100%'
        }}
      >
        <Box>
          <Typography
            component='div'
            sx={{
              display: 'flex',
              gap: '16px',
              alignItems: 'center',
              fontSize: '32px',
              height: '60px'
            }}
            variant='h2'
          >
            {icon}
            {title}
          </Typography>
          {subtitle && (
            <Typography
              component='div'
              sx={{
                color: 'var(--GX-Text-Disabled, #6C737A)',
                fontFamily: 'Cairo',
                fontSize: '12px',
                fontStyle: 'normal',
                fontWeight: 500,
                lineHeight: 'normal'
              }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
        {headerAction}
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: '2px'
        }}
      >
        <Box
          ref={historyButtonRef}
          role='button'
          sx={{
            width: 48,
            height: 130,
            backgroundColor: 'gx.tileDark',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: onHistoryClick ? 'pointer' : 'default',
            p: 0,
            position: 'relative',
            '&::after': {
              content: '""',
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              height: '3px',
              backgroundColor: isHistoryActive ? 'primary.main' : 'transparent'
            }
          }}
          onClick={onHistoryClick}
        >
          <HistoryOutlinedIcon />
        </Box>
        <Box
          role='button'
          sx={{
            width: 48,
            height: 130,
            backgroundColor: 'var(--GX-Tile-Dark, #0D1228)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer'
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </Box>
      </Box>
    </Box>
  );
};

export default Header;
